'use client'
import * as React from 'react'

import { SidePanel } from '../side-panel'
import { FloatingSidePanel } from '../side-panel/floating-side-panel'
import type { Variant } from '../config'
import { FreeTrialProductDetails } from '../product-details/free-trial'
import { ProductDetails } from '../product-details'

export function PageContainerClient({ variant }: { variant: Variant }) {
  let newVariant = variant
  if (variant === 'freeTrial') {
    newVariant = 'freeTrialYearly'
  }

  return (
    <div className="m-auto mt-0 flex h-full min-h-[405px] w-full max-w-[1220px] gap-10 self-center px-5 py-10 lg:pb-[140px]">
      <div className="flex w-full lg:max-w-[68%]">
        {newVariant !== 'freeTrialYearly' && variant !== 'freeTrialAiStudio' ? (
          <ProductDetails variant={newVariant} />
        ) : (
          <FreeTrialProductDetails
            subscriptionType={variant === 'freeTrialAiStudio' ? 'ai_studio' : 'all_access'}
          />
        )}
      </div>
      <div className="hidden w-full lg:flex lg:max-w-[32%]">
        <SidePanel variant={newVariant} />
      </div>
      <div className="bg-service-white fixed-banner fixed bottom-0 left-0 flex w-full lg:hidden">
        <FloatingSidePanel variant={newVariant} />
      </div>
    </div>
  )
}
